// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3E2YP","right":"Footer_right__HdakX","buttons":"Footer_buttons__PbUTK"};